export const CURRENT_JUDICIARY_STEP_EXPERT_REPORT = 1;
